import { useState } from "react";
import { createPortal } from "react-dom";
import ErrorMessage from "../ErrorMessage";
import classes from "./StudioEquipment.module.css";
import { useStudioErstellen } from "../../../store/studioErstellenStore";

const EquipmentPopUp = ({ 
        deleteEquipment, 
        editingItem, 
        fromEditor,
        closePopUp, 
        name, 
        equipmentItems, 
        setEquipmentItems,
        onSave,
        onSaveAndAdd,
        handleValidation
    }) => {
    const [inputName, setInputName] = useState(editingItem?.name || '');
    const { studioData, updateStudioData } = useStudioErstellen(); 
    const [errors, setErrors] = useState({
        name: ""
    });

    const handleUpdateCount = (id, count) => {
        setEquipmentItems(prevItems => prevItems.map(item => item.id === id ? { ...item, count } : item));
    };

    const handleInputChange = (e) => {
        const newName = e.target.value;
        const { isValid, errors: newErrors } = handleValidation(
            equipmentItems, 
            editingItem?.id, 
            newName
        );
        
        setErrors(newErrors);
        setInputName(newName);
        setEquipmentItems(prevItems => prevItems.map(item => ({ ...item, name: newName })));
    };

    const handleSaveAndAdd = () => {
        const { isValid, errors: newErrors } = handleValidation(
            equipmentItems, 
            editingItem?.id, 
            inputName
        );

        if (!isValid) {
            setErrors(newErrors);
            return;
        }

        if (fromEditor && typeof onSaveAndAdd === "function") {
            onSaveAndAdd(equipmentItems);
        } else {
            const updatedEquipment = {
                ...studioData.equipment,
                [name]: [...(studioData.equipment?.[name] || []), ...equipmentItems]
            };
            updateStudioData('equipment', updatedEquipment);
        }
    
        setInputName('');
        setEquipmentItems([{ 
            name: '', 
            count: 1, 
            id: Date.now()
        }]);
    };
    

    const handleSave = () => {
        const { isValid, errors: newErrors } = handleValidation(
            equipmentItems, 
            editingItem?.id, 
            inputName
        );

        if (!isValid) {
            setErrors(newErrors);
            return;
        }

        if (fromEditor && typeof onSave === "function") {
            onSave(equipmentItems, editingItem);
            closePopUp();
            return;
        }

        const updatedEquipment = {
            ...studioData.equipment,
            [name]: editingItem 
                ? studioData.equipment[name].map(item => 
                    item.id === editingItem.id ? equipmentItems[0] : item
                  )
                : [...(studioData.equipment?.[name] || []), ...equipmentItems]
        };
        onSave(updatedEquipment);
        closePopUp();
    };

    const modalContent = (
        <>
            <div className={classes.equipmentPopUpOverlay} onClick={closePopUp}></div>
        <div className={`${classes.equipmentPopUp} ${fromEditor ? classes.equipmentPopUpEditor : ''}`}>
                <div className={classes.equipmentPopUpHeader}>
                    <h2 className={`${classes.equipmentPopUpHeaderTitle} mediumLarge`}>
                        {editingItem ? `${name} bearbeiten` : `${name} hinzufügen`}
                    </h2>
                    <button onClick={closePopUp} className={classes.closeButton}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.58759 8.5L0.078125 0.990535L1.06866 0L8.57813 7.50947L16.0876 0L17.0781 0.990535L9.56866 8.5L17.0781 16.0095L16.0876 17L8.57813 9.49054L1.06866 17L0.078125 16.0095L7.58759 8.5Z" fill="#1F1F1F"/>
                        </svg>
                    </button>
                </div>
                <div className={classes.equipmentPopUpContent}>
                    <div className={classes.equipmentPopUpInputContainer}>
                        <span className={`${classes.equipmentPopUpInputLabel} regularMiddle`}>Name</span>
                        <input
                            type="text"
                            placeholder="Name eingeben"
                            className={`${classes.equipmentPopUpInput} regularMiddle`}
                            value={inputName}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className={classes.equipmentPopUpErrorContainer}>
                        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
                    </div>
                    <div className={classes.equipmentPopUpContainer}>
                        <button 
                            className={`${classes.equipmentPopUpDeleteButton} regularLarge`}
                            onClick={() => deleteEquipment(editingItem)}
                        >
                            Löschen
                        </button>
                        {equipmentItems?.map(item => (
                            <div key={item?.id} className={classes.countControl}>
                                <button 
                                    onClick={() => handleUpdateCount(item?.id, Math.max(1, item?.count - 1))}
                                    className={classes.countButton}
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="2" viewBox="0 0 12 2" fill="none">
                                    <path d="M0 1.75V0.25H12V1.75H0Z" fill={`${item?.count === 1 ? '#DEE1E5' : '#1F1F1F'}`}/>
                                </svg>
                                </button>
                                <span className={`${classes.count} regularMiddle`}>{item?.count}</span>
                                <button 
                                    onClick={() => handleUpdateCount(item?.id, item?.count + 1)}
                                    className={classes.countButton}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M5.25333 12V0H6.77333V12H5.25333ZM0 6.77333V5.25333H12V6.77333H0Z" fill="#1F1F1F"/>
                                    </svg>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                {!editingItem && (
                    <div className={classes.equipmentPopUpButtonContainer}>
                        <button 
                            className={`${classes.equipmentPopUpButton} semiboldXs`}
                            disabled={!inputName}
                            style={{ color: !inputName ? "#B1B6BB" : "var(--dark-grey)" }}
                            onClick={handleSaveAndAdd}
                        >
                            Speichern & mehr hinzufügen
                        </button>
                    </div>
                )}
                <div className={classes.speichernButtonContainer}>
                    <button 
                        disabled={!inputName} 
                        className={`${classes.speichernButton} mediumLarge`}
                        style={{ 
                            color: !inputName ? "var(--grey-2)" : "var(--white)", 
                            backgroundColor: !inputName ? "var(--light-grey-2)" : "var(--dark-grey)" 
                        }}
                        onClick={handleSave}
                    >
                        {fromEditor ? "Hinzufügen" : "Speichern"}
                    </button>
                </div>
            </div>
        </>
    );

    if (typeof document === "undefined") {
        return null;
    }

    return createPortal(modalContent, document.body);
};

export default EquipmentPopUp;